import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faHouseChimney } from '@fortawesome/free-solid-svg-icons';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {
  FileType,
  GlobalFunctions,
} from 'globales-projekt-angular';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { FileAppMetaDatas } from 'src/app/data/anwendung/file-app-meta-datas.model';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  constructor(private apiService: ApiService) {}
  showWaitingForDataSpinner: number = 0;

  faInfo = faInfo; 
  faHouseChimney = faHouseChimney;
  faDownload = faDownload;
  faQuestion = faQuestion;
  faCaretDown = faCaretDown;

  fileAppMetaDatas: FileAppMetaDatas = new FileAppMetaDatas(this.apiService);

  ngOnInit(): void {
    this.fileAppMetaDatas.loadFileAppMetaDatas();
  }

  downloadFileVerordnung() {
    this.downloadFile(
      this.fileAppMetaDatas.verordnung.type,
      DateiTyp.VERORDNUNG,
      ConstantsSonstige.FILENAME_VERORDNUNG,
      this.fileAppMetaDatas.verordnung.endung
    );
  }

  downloadFileBetriebsgroessenklassen() {
    this.downloadFile(
      this.fileAppMetaDatas.betriebsgroessenklassen.type,
      DateiTyp.BETRIEBSGROESSENKLASSEN,
      ConstantsSonstige.FILENAME_BETRIEBSGROESSENKLASSEN,
      this.fileAppMetaDatas.betriebsgroessenklassen.endung
    );
  }

  downloadFileNutsZweiRegionen() {
    this.downloadFile(
      this.fileAppMetaDatas.nuts_zwei_regionen.type,
      DateiTyp.NUTS_ZWEI_REGIONEN,
      ConstantsSonstige.FILENAME_NUTS_ZWEI_REGIONEN,
      this.fileAppMetaDatas.nuts_zwei_regionen.endung
    );
  }

  downloadFile(
    type: FileType,
    dateiTyp: DateiTyp,
    fileName: string,
    fileEndung: FileType
  ) {
    this.showWaitingForDataSpinner++;
    this.apiService
      .getAppFileDocuments(dateiTyp)
      .subscribe(async (response) => {
        GlobalFunctions.downloadFile(type, response, fileName, fileEndung);
        this.showWaitingForDataSpinner--;
      });
  }
}
